<script setup lang="ts">
</script>
<template>
    <div class="tw-w-[1005] tw-p-[4px] tw-rounded-[50%] tw-bg-[#EAECF9]">
        <img class="tw-w-[100%] tw-object-contain" src="@/assets/images/user.svg" alt="user" width="24" height="24">
    </div>
</template>
<style scoped>
</style>
